import React from "react";
import {Button, Dropdown, Tag} from "antd";
import type {ColumnsType} from "antd/es/table";
import type {MenuProps} from "antd";
import {EllipsisOutlined} from "@ant-design/icons";
import type {EmailAutomationRow, EmailAutomationStatus} from "./types";
import {statusTag} from "./constants";

export function useEmailAutomationsColumns(
  onMenuClick: (key: string, record: EmailAutomationRow) => void
): ColumnsType<EmailAutomationRow> {
  const getActionItems = (): MenuProps["items"] => [
    {key: "view", label: "View details"},
    {key: "edit", label: "Edit"},
    {key: "duplicate", label: "Duplicate"},
    {key: "delete", label: "Delete", danger: true},
  ];

  return [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text) => <span style={{color: "#1c1726"}}>{text}</span>,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      align: "center",
      render: (status: EmailAutomationStatus) => (
        <Tag
          color={statusTag[status].color}
          style={
            status === "Paused"
              ? {
                  background: "#f5f5f5",
                  border: "1px solid #d9d9d9",
                  color: "#595959",
                }
              : undefined
          }
        >
          {status}
        </Tag>
      ),
    },
    {
      title: "Offerings",
      dataIndex: "offerings",
      key: "offerings",
      align: "center",
    },
    {
      title: "Sent",
      dataIndex: "sent",
      key: "sent",
      align: "center",
    },
    {
      title: "Delivered",
      dataIndex: "delivered",
      key: "delivered",
      align: "center",
    },
    {
      title: "",
      key: "action",
      align: "center",
      width: 56,
      render: (_, record) => (
        <Dropdown
          menu={{
            items: getActionItems(),
            onClick: ({key}) => onMenuClick(key, record),
          }}
          trigger={["click"]}
          placement="bottomRight"
          overlayStyle={{minWidth: 200}}
          overlayClassName="email-automations-actions-dropdown"
        >
          <Button type="text" icon={<EllipsisOutlined style={{fontSize: 18}} />} />
        </Dropdown>
      ),
    },
  ];
}
